import { Address } from '../types'

export const EMPTY_ADDRESS: Address = {
  province: '',
  provinceCode: '',
  region: '',
  regionCode: '',
  country: '',
  countryCode: '',
  streetName: '',
  streetNumber: '',
  zipCode: '',
  city: '',
  cityCode: '',
  plainAddress: '',
  placeId: '',
  position: {
    type: 'Point',
    coordinates: [0, 0],
  },
}
